// lib/watoken.js
// Captura y persistencia del token de atribución de WhatsApp (?wa=).
//
// Cuando mandamos un template por WhatsApp con botón URL dinámico, cada destinatario
// recibe un link con ?wa=TOKEN (token único por envío, generado en admin-back y
// logueado en wa_template_sends). Al aterrizar acá lo persistimos en cookie
// first-party + localStorage (mismo patrón que gclid) y en el checkout viaja en
// ad.waToken hasta sales.waToken. Así la compra queda atribuida al template y al
// número exacto de WhatsApp, aunque el comprador pague con un mail que nunca vimos.

import { getCookie } from "@/utils/cookies";

const KEY = "bcm_wa";
const MAX_AGE_DAYS = 30; // ventana de atribución del envío

// Forma del token generado en admin-back (random_bytes(9) en base64url = 12 chars).
// El tope de 24 es el ancho de sales.waToken: un valor más largo llegaría al INSERT
// y lo haría fallar. Se valida al leer y no solo al escribir, porque la cookie es
// del cliente y puede venir editada a mano.
const TOKEN_RE = /^[A-Za-z0-9_-]{6,24}$/;

/**
 * Lee ?wa= de la URL actual y lo persiste. Llamar una vez por pageload (GoogleAdsTag).
 */
export function captureWaToken() {
  if (typeof window === "undefined") return;
  try {
    const v = new URLSearchParams(window.location.search).get("wa");
    if (!v || !TOKEN_RE.test(v)) return;

    const maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
    document.cookie = `${KEY}=${encodeURIComponent(v)}; max-age=${maxAge}; path=/; SameSite=Lax`;
    try {
      window.localStorage.setItem(KEY, JSON.stringify({ v, t: Date.now() }));
    } catch {
      /* localStorage puede estar bloqueado (modo privado) */
    }
  } catch {
    /* nunca romper la página por analytics */
  }
}

/** Token vigente o null. Orden: cookie propia -> localStorage (si no venció). */
export function getWaToken() {
  if (typeof window === "undefined") return null;

  const own = getCookie(KEY);
  if (own && TOKEN_RE.test(own)) return own;

  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw) {
      const { v, t } = JSON.parse(raw);
      if (v && TOKEN_RE.test(v) && t && Date.now() - t < MAX_AGE_DAYS * 864e5) return v;
    }
  } catch {
    /* ignore */
  }
  return null;
}
